import { c as _c } from "react/compiler-runtime";
import { toast } from '@systemeio/ui';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useSaveEmail = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post,
      badRequestHandler: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    const saveEmail = email => fetcher("/api/dashboard/profile/change-email", {
      email
    });
    t1 = {
      saveEmail
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
function _temp(error) {
  if (error.errors.fields && error.errors.fields.email) {
    toast.error(error.errors.fields.email.join("\n"));
  }
}